/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_baseGt.js
 ** module id = 241
 ** module chunks = 0
 **/